























import { Prop, Component, Vue } from 'vue-property-decorator'
import { BranchTarget } from '@/api/model/branch-target'
import { BranchTargetAPI } from '@/api/backend-client'
import { Branch } from '@/api/model/branch'
import { Pipeline } from '@/api/model/pipeline'
import { v4 as uuid } from 'uuid'
import { escapeHtml } from '@/helpers/html'

export interface CreateTargetFormModel {
    fromDate: Date,
    untilDate: Date,
    referralPipeline: Pipeline|null,
    referralType: string,
    orderType: string,
    direction: string,
    quantity: number,
    turnover: number,
}

@Component
export default class TargetsCreate extends Vue {
    @Prop({ required: true }) readonly team: Branch|null
    submitting: boolean = false
    createTargetForm: CreateTargetFormModel = {
        fromDate: null,
        untilDate: null,
        referralPipeline: null,
        referralType: null,
        orderType: null,
        direction: 'out',
        quantity: null,
        turnover: null,
    }

    resetForm(): void {
        this.createTargetForm = {
            fromDate: null,
            untilDate: null,
            referralPipeline: null,
            referralType: null,
            orderType: null,
            direction: 'out',
            quantity: null,
            turnover: null,
        }
    }

    async createTarget(): Promise<void> {
        try {
            this.submitting = true
            const target = BranchTarget.fromData({
                branch: this.team.resourceIdentifier,
                id: uuid(),
                fromDate: this.createTargetForm.fromDate,
                untilDate: this.createTargetForm.untilDate,
                referralPipeline: this.createTargetForm.referralPipeline,
                referralType: this.createTargetForm.referralType,
                orderType: this.createTargetForm.orderType,
                direction: this.createTargetForm.direction,
                quantity: this.createTargetForm.quantity,
                turnover: this.createTargetForm.turnover,
            })

            await BranchTargetAPI.create(target)
            this.onCreated(target)

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })

        } finally {
            this.submitting = false
        }
    }

    onCreated(target: BranchTarget): void {
        this.$emit('created', target)
    }

    onCancel(): void {
        this.$emit('cancel')
    }
}
